import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.Home';

export default defineMessages({
  HeroHeading: {
    id: `${scope}.heroHeading`,
    defaultMessage: 'Poslovi u krugu prilika',
  },
  HeroHeadingLg: {
    id: `${scope}.heroHeadingLg`,
    defaultMessage: 'Pronađi svoju i prijavi se još danas!',
  },
  Searching: {
    id: `${scope}.searching`,
    defaultMessage: 'Pretraga',
  },
  AdditionalFilters: {
    id: `${scope}.additionalFilters`,
    defaultMessage: 'Dodatni filteri',
  },
  HideAdditionalFilters: {
    id: `${scope}.hideAdditionalFilters`,
    defaultMessage: 'Zatvori dodatne filtere',
  },
  JobDisability: {
    id: `${scope}.jobDisability`,
    defaultMessage: 'Posao za osobe sa invaliditetom',
  },
  JobAge: {
    id: `${scope}.jobAge`,
    defaultMessage: 'Posao za osobe sa 50+ godina starosti',
  },
  JobStudent: {
    id: `${scope}.jobStudent`,
    defaultMessage: 'Poslovi za studente',
  },
  JobAbroad: {
    id: `${scope}.JobAbroad`,
    defaultMessage: 'Poslovi u inostranstvu',
  },
  JobSalary: {
    id: `${scope}.JobSalary`,
    defaultMessage: 'Samo poslovi sa naznačenom platom',
  },
  Remote: {
    id: `${scope}.remote`,
    defaultMessage: 'Rad od kuće',
  },
  ProminentAdsTitle: {
    id: `${scope}.prominentAdsTitle`,
    defaultMessage: 'Premium oglasi',
  },
  OurOfferTitle: {
    id: `${scope}.ourOfferTitle`,
    defaultMessage: 'Naša ponuda',
  },
  AdsCreation: {
    id: `${scope}.adsCreation`,
    defaultMessage: 'Postavljanje oglasa',
  },
  AdsCreationDesc: {
    id: `${scope}.adsCreationDesc`,
    defaultMessage: 'loop ti nudi različite mogućnosti kreiranja oglasa u zavisnosti od tvojih potreba.',
  },
  AdsCreationDesc2: {
    id: `${scope}.adsCreationDesc2`,
    defaultMessage: 'Odaberi unared pripremljene opise dužnosti i zahteva koje je loop pripremio za određene pozicije, potpuno samostalno kreiraj svoj oglas ili dozvoli loop konsultantu da u potpunosti kreira sadržaj oglasa na osnovu tvoje glasovne poruke.',
  },
  SignUpCandidates: {
    id: `${scope}.signUpCandidates`,
    defaultMessage: 'Procena prijavljenih kandidata',
  },
  SignUpCandidatesDesc: {
    id: `${scope}.signUpCandidatesDesc`,
    defaultMessage: 'Nakon aktiviranja usluge procene prijavljenih kandidata, loop će ti prikazati odgovarajuće i neodgovarajuće prijavljene kandidate, uz isticanje do TOP 10 prijava.',
  },
  SignUpCandidatesDesc2: {
    id: `${scope}.signUpCandidatesDesc2`,
    defaultMessage: 'loop obezbeđuje prilagođena rešenja u predselekciji za specifične zahteve i potrebe.',
  },
  BestCandidates: {
    id: `${scope}.bestCandidates`,
    defaultMessage: 'Odabir najboljih kandidata',
  },
  BestCandidatesDesc: {
    id: `${scope}.bestCandidatesDesc`,
    defaultMessage: 'Nakon aktivirane usluge odabira najboljih kandidata, loop će ti prikazati odgovarajuće i neodgovarajuće prijavljene kandidate i preporučiti TOP 5 najboljih kandidata po otvorenoj poziciji',
  },
  BestCandidatesDesc2: {
    id: `${scope}.bestCandidatesDesc2`,
    defaultMessage: 'loop obezbeđuje prilagođena rešenja u selekciji za specifične zahteve i potrebe.',
  },
  ClickFromYouTest: {
    id: `${scope}.clickFromYouTest`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti profesionalne procene i testiranja.',
  },
  ClickFromYouDev: {
    id: `${scope}.clickFromYouDev`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti profesionalnog razvoja.',
  },
  ClickFromYouMarketResearch: {
    id: `${scope}.clickFromYouMarketResearch`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti istraživanja tržišta.',
  },
  ClickFromYouDesc: {
    id: `${scope}.clickFromYouDescDev`,
    defaultMessage: 'Stručni ljudi su ključ svakog uspešnog biznisa. Kreirajte Vaš oglas',
  },
  RegistrationAndSelection: {
    id: `${scope}.registrationAndSelection`,
    defaultMessage: 'Registracija i selekcija',
  },
  MarketResearch: {
    id: `${scope}.marketResearch`,
    defaultMessage: 'Istraživanje tržišta',
  },
  MarketResearchDesc: {
    id: `${scope}.marketResearchDesc`,
    defaultMessage: 'loop sa svojim partnerima donosi relevantne informacije sa tržišta i ekspertske smernice u vezi sa strateškim pitanjima vezanim za vaše poslovanje. Putem Loop-a ćeš saznati:',
  },
  MarketResearchDesc2: {
    id: `${scope}.marketResearchDesc2`,
    defaultMessage: 'I još mnogo toga...',
  },
  MarketResearchDesc3: {
    id: `${scope}.marketResearchDesc3`,
    defaultMessage: 'Nakon popunjavanja upita, u toku od 48h ćeš dobiti informacije o ceni i trajanju usluge.',
  },
  MarketResearchDescList1: {
    id: `${scope}.marketResearchDescList1`,
    defaultMessage: 'Kako se kreću zarade na tržištu za određenu poziciju/pozicije',
  },
  MarketResearchDescList2: {
    id: `${scope}.marketResearchDescList2`,
    defaultMessage: 'Kako uspostaviti odgovarajući sistem kompenzacija i beneficija',
  },
  MarketResearchDescList3: {
    id: `${scope}.marketResearchDescList3`,
    defaultMessage: 'Koliko su vaši zaposleni zadovoljni i uključeni',
  },
  MarketResearchDescList4: {
    id: `${scope}.marketResearchDescList4`,
    defaultMessage: 'Dostupnost određenih profila na tržištu',
  },
  MarketResearchDescList5: {
    id: `${scope}.marketResearchDescList5`,
    defaultMessage: 'Kako unaprediti employer branding',
  },
  EstimatesAndTests: {
    id: `${scope}.estimatesAndTests`,
    defaultMessage: 'Procene i testovi',
  },
  EmployeeDevelopment: {
    id: `${scope}.employeeDevelopment`,
    defaultMessage: 'Razvoj zaposlenih',
  },
  SeeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: 'Vidi više',
  },
  RecentNewsTitle: {
    id: `${scope}.recentNewsTitle`,
    defaultMessage: 'Glas tržišta',
  },
  SeeAllNews: {
    id: `${scope}.seeAllNews`,
    defaultMessage: 'Vidi sve',
  },
  SetNews: {
    id: `${scope}.setNews`,
    defaultMessage: 'Budi glas tržišta',
  },
  SelectCategory: {
    id: `${scope}.selectCategory`,
    defaultMessage: 'Izaberi kategoriju',
  },
  PopularNews: {
    id: `${scope}.popularNews`,
    defaultMessage: 'Najčitanije',
  },
  EventsTitle: {
    id: `${scope}.eventsTitle`,
    defaultMessage: 'Događaji na vidiku',
  },
  SeeAllEvents: {
    id: `${scope}.seeAllEvents`,
    defaultMessage: 'Vidi sve',
  },
  SetEvent: {
    id: `${scope}.setEvent`,
    defaultMessage: 'Oglasi događaj',
  },
  OurClientsTitle: {
    id: `${scope}.ourClientsTitle`,
    defaultMessage: 'Klijenti u krugu prilika',
  },
  BusinessHelp: {
    id: `${scope}.businessHelp`,
    defaultMessage: 'Da li su potrebni novi članovi tima?',
  },
  CreateYourAd: {
    id: `${scope}.createYourAd`,
    defaultMessage: 'loop informiše tržište i naše korisnike o jedinstvenoj prilici u tvojoj kompaniji.',
  },
  ViewOfBiography: {
    id: `${scope}.viewOfBiography`,
    defaultMessage: 'Želiš li da znaš koje su prijave odgovarajuće?',
  },
  ViewOfBiographyDesc: {
    id: `${scope}.viewOfBiography`,
    defaultMessage: 'loop pregleda i proverava pristigle prijave na oglas kako bi identifikovao kandidate koje ispunjavaju postavljene kriterijume.',
  },
  DoYouWantToKNow: {
    id: `${scope}.doYouWantToKNow`,
    defaultMessage: 'Želiš li da znaš koji su najbolji kandidati među prijavljenima?',
  },
  DoYouWantToKNowDesc: {
    id: `${scope}.doYouWantToKNowDesc`,
    defaultMessage: 'loop proverava da li prijavljeni kandidati ispunjavaju postavljene kriterijume i vrši odabir najboljih kandidata.',
  },
  ProDevelopment: {
    id: `${scope}.proDevelopment`,
    defaultMessage: 'Profesionalni razvoj',
  },
  ProDevelopmentDesc: {
    id: `${scope}.proDevelopmentDesc`,
    defaultMessage: 'loop sa svojim partnerima donosi razvojna rešenja, inovativne programe i metodologije namenjene profesionalnom razvoju. Putem loop-a obezbedi sebi ili svojim zaposlenima:',
  },
  ProDevelopmentDescList1: {
    id: `${scope}.proDevelopmentDescList1`,
    defaultMessage: 'Individualne razvojne programe i programe podrške',
  },
  ProDevelopmentDescList2: {
    id: `${scope}.proDevelopmentDescList2`,
    defaultMessage: 'Grupne razvojne programe',
  },
  ProDevelopmentDescList3: {
    id: `${scope}.proDevelopmentDescList3`,
    defaultMessage: 'Gejmifikovana rešenja',
  },
  ProTest: {
    id: `${scope}.proTest`,
    defaultMessage: 'Profesionalna procena i testiranje',
  },
  ProTestDesc: {
    id: `${scope}.proTestDesc`,
    defaultMessage: 'loop sa svojim partnerima donosi moćne alate i metodologije za profesionalnu procenu i testiranje za lične ili korporativne potrebe. Putem loop-a možeš dobiti pouzdane i precizne informacije o:',
  },
  ProTestDescList1: {
    id: `${scope}.proTestDescList1`,
    defaultMessage: 'Razvojnim potrebama',
  },
  ProTestDescList2: {
    id: `${scope}.proTestDescList2`,
    defaultMessage: 'Uklapanju kandidata sa pozicijom/kompanijom',
  },
  ProTestDescList3: {
    id: `${scope}.proTestDescList3`,
    defaultMessage: 'Opštim i specifičnim sposobnostima',
  },
  ProTestDescList4: {
    id: `${scope}.proTestDescList4`,
    defaultMessage: 'Ličnosti',
  },
  SearchingForJob: {
    id: `${scope}.searchingForJob`,
    defaultMessage: 'korisnika upravo traga za svojim novim poslom',
  },
  HaveNewMessagePartI: {
    id: `${scope}.HaveNewMessagePartI`,
    defaultMessage: 'Treba ti <strong>savet</strong>?',
  },
  HaveNewMessagePartII: {
    id: `${scope}.HaveNewMessagePartII`,
    defaultMessage: 'Registruj se i piši nam.',
  },
  HaveNewApplicationPartI: {
    id: `${scope}.HaveNewApplicationPartI`,
    defaultMessage: '<strong>Apliciraj</strong> na oglase i prati',
  },
  HaveNewApplicationPartII: {
    id: `${scope}.HaveNewApplicationPartII`,
    defaultMessage: '<strong>statuse</strong> svojih prijava.',
  },
  Note: {
    id: `${scope}.note`,
    defaultMessage: 'Obaveštenje!',
  },
  Results: {
    id: `${scope}.results`,
    defaultMessage: 'Odgovori na <strong>upite poslodavaca</strong>',
  },
  yourDigitalPartner: {
    id: `${scope}.yourDigitalPartner`,
    defaultMessage: 'Tvoj krug prilika',
  },
  yourDigitalPartnerSubTitle: {
    id: `${scope}.yourDigitalPartnerSubTitle`,
    defaultMessage: '<strong>... a prilike nisu samo oglasi za posao.</strong> ',
  },
  criteriaModalTitle: {
    id: `${scope}.criteriaModalTitle  `,
    defaultMessage: 'Poslovi po tvojoj meri!',
  },
  criteriaModalText1: {
    id: `${scope}.criteriaModalText1  `,
    defaultMessage: 'Želiš da znaš kada se pojave poslovne prilike koje su odgovarajuće za tebe?',
  },
  criteriaModalText2: {
    id: `${scope}.criteriaModalText2`,
    defaultMessage: 'Obaveštavaćemo te o novim oglasima koji su u skladu sa tvojim interesovanjima.',
  },
  criteriaModalText3: {
    id: `${scope}.criteriaModalText3`,
    defaultMessage: 'Na tebi je samo da nam kažeš koji poslovi te zanimaju.',
  },
  criteriaModalText4: {
    id: `${scope}.criteriaModalText4`,
    defaultMessage: 'Klik na <span>Poslovi za mene!</span>',
  },
  criteriaModalButton: {
    id: `${scope}.criteriaModalButton`,
    defaultMessage: 'Poslovi za mene',
  },
});
